module.exports = __webpack_public_path__ + "static/media/bez_temp_w_domu_grzanie_2.fb961421.svg";